import axios from 'axios' // See: https://raw.githubusercontent.com/FullTimeVue/vue-rest-api-sample/master/src/helpers/http.js
import store from '../store'
import router from '../router'
import bugsnagClient from './bugsnag'

const DEFAULT_HEADERS = {}

const validStatuses = [
  200, 201, 202, 203, 204,
  300, 301, 302, 303, 304,
  422 // This is specific for invalid confirmation tokens
]

/*
 * Returns default headers list
 * which will be used with every request.
 */
function getHeaders (multipart = false, uri, userId = false) {
  let defaultHeaders = DEFAULT_HEADERS

  if (userId !== false) {
    defaultHeaders = {
      'Authorization': 'Bearer ' + userId
    }
  }

  if (multipart) {
    defaultHeaders = {}
  }

  return defaultHeaders
}

export function checkResponse (response) {
  // TODO: Need to revise this. This is here to handle 500's from axios
  if (typeof response === 'undefined') {
    return false
  }

  if (response.statusText === '' && response.status === 401) {
    store.commit('modalText', 'Your session expired, you will have to login again.')
    setTimeout(function () {
      router.push('/logout')
    }, 1000)
    return false
  } else if (
    response.status === 400 &&
    response.data &&
    response.data.inputErrors &&
    response.data.inputErrors.phone) {
    store.commit('setErrorMsg', response.data.inputErrors.phone[0])
    store.commit('setError', true)
  }

  if (validStatuses.includes(response.status)) {
    return response
  }

  let err = new Error(response.statusText)
  err.response = response

  return Promise.reject(err)
}

export function processAPIErrors (apiErrors) {
  let errors = {}

  if (apiErrors) {
    for (let key of Object.keys(apiErrors)) {
      let err = apiErrors[key]

      errors[key] = err

      if (typeof err === 'object' || err.hasOwnProperty('length')) {
        errors[key] = apiErrors[key][0]
      }
    }
  }

  return errors
}

export const esc = encodeURIComponent

export function qs (params) {
  return (
    Object
      .keys(params)
      .map(k => esc(k) + '=' + esc(params[k]))
      .join('&')
  )
}

/*
 * Wraps axios and provides
 * more convenient post method
 * calls with data
 */
export function post (uri, data, userId) {
  return axios.post(uri, data, {
    headers: getHeaders(false, uri, userId),
    validateStatus: function (status) {
      return status < 500
    }
  }).catch(error => {
    bugsnagClient.notify(error)
  }).then(response => {
    return response
  })
}

/*
 * Wraps axios and provides
 * more convenient put method
 * calls with data
 */
export function put (uri, data) {
  return axios.put(uri, data, {
    headers: getHeaders(),
    validateStatus: function (status) {
      return status < 500
    }
  })
}

/*
 * Wraps axios and provides
 * more convenient delete method
 */
export function remove (uri) {
  return axios.delete(uri, {
    headers: getHeaders(),
    validateStatus: function (status) {
      return status < 500
    }
  })
}

/*
 * Wraps axios and provides
 * more convenient get method
 * calls with data.
 */
export function get (uri, data = {}, userId) {
  if (Object.keys(data).length > 0) {
    uri = `${uri}?${qs(data)}`
  }

  return axios.get(uri, {
    headers: getHeaders(false, uri, userId),
    validateStatus: function (status) {
      return status < 500
    }
  }).catch(error => {
    bugsnagClient.notify(error)
  }).then(response => {
    return response
  })
}

export function upload (uri, data) {
  return fetch(uri, {
    headers: getHeaders(true),
    cors: true,
    method: 'POST',
    body: data
  })
}
